import React from "react"
import {Calendar} from "../../../CalendarPsico/Calendar"
export default function Calendario() {
  
  return (
    <>
        <Calendar/>
    </>
  )

}
